<article class="flex flex-col gap-12 overflow-hidden">
  <section class="flex flex-col gap-6 bg-lGray900 rounded-3xl p-6">

    <div class="flex items-start justify-between">
      <div class="flex flex-col gap-1">
        <h2 class="text-xl font-bold text-color">{{ title }}</h2>
        <p class="text-sm subtext-color">{{ subtitle }}</p>
      </div>
      <button (click)="close()" class="text-lGray500 hover:text-lGray300 transition-colors p-1">
        <l-icon class="text-2xl">close</l-icon>
      </button>
    </div>

    <div class="flex justify-center">
      <img
        src="assets/icons/users.svg"
        [alt]="illustrationAlt"
        class="h-36 w-auto object-contain"
      />
    </div>

    <form [formGroup]="formGroup" class="flex flex-col gap-4" (ngSubmit)="submit()">
      <div class="flex flex-col gap-1">
        <label for="create-user-name" class="text-sm font-medium text-lGray500">
          Nome <span class="text-lDanger">*</span>
        </label>
        <div class="relative">
          <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 subtext-color text-xl">person</l-icon>
          <input
            id="create-user-name"
            lInput
            formControlName="name"
            placeholder="Nome completo"
            class="pl-11 border-none rounded-xl"
            [ngClass]="{ '!border-lDanger': nameControl.invalid && nameControl.touched }"
          />
        </div>
        @if (nameControl.invalid && nameControl.touched) {
          <small class="text-lDanger text-xs">Nome é obrigatório</small>
        }
      </div>
      
      <div class="flex flex-col gap-1">
        <label for="create-user-email" class="text-sm font-medium text-lGray500">
          E-mail <span class="text-lDanger">*</span>
        </label>
        <div class="relative">
          <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 subtext-color text-xl">mail</l-icon>
          <input
            id="create-user-email"
            lInput
            formControlName="email"
            type="email"
            placeholder="Digite o e-mail"
            class="pl-11 border-none rounded-xl"
            [ngClass]="{ '!border-lDanger': emailControl.invalid && emailControl.touched }"
          />
        </div>
        @if (emailControl.touched) {
          @if (emailControl.hasError('required')) {
            <small class="text-lDanger text-xs">E-mail é obrigatório</small>
          } @else if (emailControl.hasError('email')) {
            <small class="text-lDanger text-xs">E-mail inválido</small>
          }
        }
      </div>
      
      <div class="flex flex-col gap-1">
        <label for="create-user-position" class="text-sm font-medium text-lGray500">Cargo</label>
        <div class="relative">
          <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 subtext-color text-xl">badge</l-icon>
          <input
            id="create-user-position"
            lInput
            formControlName="position"
            placeholder="Digite o cargo"
            class="pl-11 border-none rounded-xl"
          />
        </div>
      </div>
      
      <div class="flex flex-col gap-1">
        <label for="create-user-sector" class="text-sm font-medium text-lGray500">Setor</label>
        <p-select
          inputId="create-user-sector"
          formControlName="sectorId"
          [options]="sectors"
          optionLabel="name"
          optionValue="id"
          placeholder="Selecione o setor"
          [showClear]="true"
          class="w-full"
        />
      </div>

      <p class="text-xs text-lDanger">(*) Campos obrigatórios</p>

    </form>
  </section>
  
  <section class="flex justify-center">
    <button
      lButton
      [bType]="formGroup.invalid || isSubmitting ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
      [bSize]="buttonSizeEnum.MEDIUM"
      [bRadius]="buttonRadiusEnum.LARGE"
      [disabled]="formGroup.invalid || isSubmitting"
      (click)="submit()"
    >
      @if (isSubmitting) {
        <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
      }

      {{ submitLabel }}
    </button>
  </section>
  
</article>

